import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  color: {
    position: "relative",
    width: "26px",
    height: "26px",
    borderRadius: "4px",
    background: (p) => p.color,
  },
  colorInner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "23px",
    height: "23px",
    borderRadius: "4px",
    border: `2px solid ${theme.app.background[1]}`,
  },
}));

const ActivityColor = (props) => {
  const classes = useStyles(props);
  return (
    <div className={classes.color}>
      <div className={classes.colorInner} />
    </div>
  );
};

export default ActivityColor;
